
import { debounce } from 'lodash';
import { defineComponent, handleError, ref } from 'vue';
import { dataServiceFactory } from '@/definitions/services/data.services';
import { Report } from '@/api';
import { ReportsFilter } from '@/api/models/ReportsFilter';
import NInput from '@/uikit/input/NInput.vue';
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';
import PageContentLayout from '@/pages/PageContentLayout.vue';
import { ReportsPageDownloader, ReportsPageActions, ReportsPageTable } from './components';
import { ReportFormat } from './components/downloader/services';
import { useReportsPageViewModel } from './setup';
import { isEmpty } from './utils';

export default defineComponent({
  name: 'ReportsPage',
  components: {
    NInput,
    NLoadingCircle,
    PageContentLayout,
    ReportsPageActions,
    ReportsPageDownloader,
    ReportsPageTable
  },
  setup() {
    const downloader = ref<InstanceType<typeof ReportsPageDownloader> | null>(null);
    const service = dataServiceFactory.getService<Report, ReportsFilter>('/reports/');
    const dataQa = 'reports';
    return { downloader, ...useReportsPageViewModel(service), dataQa};
  },
  methods: {
    handleDownload(report: Report, format: ReportFormat): void {
      this.downloader?.download(report, format);
    },
    handleDownloadSelected(): void {
      const name = `reports_${Date.now()}`;
      const reports = this.getSelectedReadyReports();
      !isEmpty(reports) && this.downloader?.downloadAllInArchive(reports, name).then(this.clearSelections);
    }
  },
  watch: {
    searchQuery() {
      if (!this.loading) this.loading = true;
      const debounced = debounce(this.load, 1000);
      debounced();
    }
  }
});
